import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import { responsiveStyles } from "scmp-app/components/header/features/styles";

import LogoPostMagazineText from "./logo-post-magazine-text.svg";

export const StyledLogoLink = styled(BaseLink)`
  ${responsiveStyles}
`;

export const StyledPostMagazineLogoText = styled(LogoPostMagazineText)`
  margin-block-start: 4.41px;
`;
